import { render } from "./LottieTest.vue?vue&type=template&id=6ceb2218"
import script from "./LottieTest.vue?vue&type=script&lang=js"
export * from "./LottieTest.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__